export const WIDGET = {
  launcher: "chat-widget-launcher",
  panel: "chat-widget-panel",
  closeBtn: "chat-widget-close",
  whatsappBtn: "chat-widget-whatsapp",
  input: "chat-widget-input",
  sendBtn: "chat-widget-send",
  quickReply: "chat-widget-quick-reply",
  messageBot: "chat-message-bot",
  messageUser: "chat-message-user",
  leadFormCard: "chat-lead-form-card",
  leadNameInput: "lead-name-input",
  leadCompanyInput: "lead-company-input",
  leadPhoneInput: "lead-phone-input",
  leadProvinceSelect: "lead-province-select",
  leadCityInput: "lead-city-input",
  leadNeedsInput: "lead-needs-input",
  leadSubmitBtn: "lead-submit-btn",
  leadSkipBtn: "lead-skip-btn",
};

export const LANDING = {
  heroCta: "landing-hero-cta",
  openChatCta: "landing-open-chat-cta",
  embedCode: "landing-embed-code",
  copyEmbedBtn: "landing-copy-embed-btn",
  adminLink: "landing-admin-link",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logoutBtn: "admin-logout-btn",
  leadsTable: "admin-leads-table",
  leadsSearch: "admin-leads-search",
  leadRow: "admin-lead-row",
  conversationsList: "admin-conversations-list",
  conversationItem: "admin-conversation-item",
  statTotalLeads: "stat-total-leads",
  statNewLeads: "stat-new-leads",
  statConversations: "stat-conversations",
  statMessages: "stat-messages",
};
